import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import type { RootState, AppDispatch } from './store'
import { setPref } from './features/prefs/prefSlice'
import { useState } from 'react'

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector


export const useReduxPrefState = (key: string, initValue: any) => 
{
    const dispatch = useAppDispatch();
    const currentValue = useAppSelector(state => state.pref[key]);
    
    if (!currentValue)
    {
        dispatch(setPref({ key: key, value: initValue }));
    }

    return [useAppSelector(state => state.pref[key]),
        (t: any) => dispatch(setPref({ key: key, value: t }))];
}

export function useHistoryState<T>(label: string, initValue: T) : [T, (t: T) => void]
{
    const [state,setState] = useState<T>(window.history.state && window.history.state[label] !== undefined ? window.history.state[label] : initValue);

    const updateState = (t: T) => {
        const existingState = window.history.state ? window.history.state : {[label]: state};
        if(state !== t) {
            setState(t);
        }
        const newState = {...existingState, [label]: t};
        window.history.replaceState(newState,"");
    };

    return [state,(t: T) => updateState(t)];
}